import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetCutOffList = () =>
    request({
        url: ApiURL.Query.GetCutOffList,
        method: RequestType.GET,
    });

const GetDistanceRanges = () =>
    request({
        url: ApiURL.Query.GetDistanceRanges,
        method: RequestType.GET,
    });

const GetCountryCutOffAddressEntityTypeByRuleBFF = () =>
    request({
        url: ApiURL.Query.GetCountryCutOffAddressEntityTypeByRuleBFF,
        method: RequestType.GET,
    });

const GetAllDeliveryType = () =>
    request({
        url: ApiURL.Query.GetAllDeliveryType,
        method: RequestType.GET,
    });

const GetWarehousesByCountry = () =>
    request({
        url: ApiURL.Query.GetWarehousesByCountry,
        method: RequestType.GET,
    });

const GetShippingCompanyCutOffList = (params: any) =>
    request({
        url: ApiURL.Query.GetShippingCompanyCutOffList,
        method: RequestType.POST,
        data: params,
    });

const GetLocationDistanceMatrix = (params: { departureLocationId: number; arrivalLocationId: number }) =>
    request({
        url: ApiURL.Query.GetLocationDistanceMatrix,
        method: RequestType.GET,
        params,
    });

const CutOffQuery = {
    GetCutOffList,
    GetDistanceRanges,
    GetCountryCutOffAddressEntityTypeByRuleBFF,
    GetAllDeliveryType,
    GetWarehousesByCountry,
    GetShippingCompanyCutOffList,
    GetLocationDistanceMatrix,
};

export default CutOffQuery;
